import React, { useContext } from "react";
import Table from "react-bootstrap/esm/Table";
import { Store } from "../Store";
import Accordion from "react-bootstrap/Accordion";
import "./sidebar.css";
import { Link } from "react-router-dom";

// Which permission(s) reveal each menu section. Mirrors AGENT_MENU_PERMISSIONS
// in backend/utils.js — holding ANY listed permission shows the section.
// Dashboard has no entry: every agent sees it. Admins hold every permission
// implicitly (the login payload sets them all true), so they see everything.
const SECTION_PERMISSIONS = {
  topups: ["canApproveTopups"],
  orders: ["canManageOrders"],
  products: ["canAddProduct", "canManageStock", "canPrintSticker"],
  withdraw: ["canManageWithdraw"],
  users: ["canManageStaff"],
  reports: ["canViewReports"],
  delivery: ["canDeliver"],
};

export default function AgentSideBar() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const perms = userInfo?.permissions || {};

  // Admin sees all; otherwise a section shows if the agent holds any of its
  // permissions. The server re-checks every endpoint, so this is menu-only.
  const can = (section) =>
    Boolean(
      userInfo?.isAdmin ||
        (SECTION_PERMISSIONS[section] || []).some((p) => perms[p])
    );

  const signoutHandler = () => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
    localStorage.removeItem("shippingAddress");
    localStorage.removeItem("paymentMethod");
    window.location.reload();
  };

  const iconStyle = { paddingRight: "10px" };

  return (
    <div
      id="agentSideBar"
      style={{
        width: "12%",
        background: "#42b4e7",
        height: "100vh",
        float: "left",
      }}
    >
      <Table>
        <thead>
          <tr>
            <td>
              <Link to="/agent/dashboard" className="navbar-brand">
                <img
                  src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                  height="30px"
                  alt="Icon marketing"
                  style={{ background: "white", borderRadius: "15px" }}
                />
              </Link>
            </td>
          </tr>
        </thead>
      </Table>
      <Accordion style={{ width: "90%", margin: "auto" }}>
        {/* Dashboard — always visible. */}
        <Accordion.Item eventKey="1">
          <Accordion.Header className="sidebar-menu">
            <i className="fa fa-tachometer" style={iconStyle} aria-hidden="true"></i>
            {"   "} General
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/agent/dashboard">Dashboard</Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        {can("topups") && (
          <Accordion.Item eventKey="04">
            <Accordion.Header className="sidebar-menu">
              <i className="fa fa-money" style={iconStyle} aria-hidden="true"></i>
              {"   "} Topups
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <Link to="/agent/topup">Topup Requests</Link>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {can("orders") && (
          <Accordion.Item eventKey="07">
            <Accordion.Header className="sidebar-menu">
              <i className="fa fa-tasks" style={iconStyle} aria-hidden="true"></i>
              {"   "} Orders
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <Link to="/agent/orders">Manage Orders</Link>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {can("products") && (
          <Accordion.Item eventKey="06">
            <Accordion.Header className="sidebar-menu">
              <i className="fa fa-cubes" style={iconStyle} aria-hidden="true"></i>
              {"   "} Products
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <Link to="/agent/products">All Products</Link>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {can("reports") && (
          <Accordion.Item eventKey="08">
            <Accordion.Header className="sidebar-menu">
              <i className="fa fa-bar-chart" style={iconStyle} aria-hidden="true"></i>
              {"   "} Reports
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <Link to="/pm">Reports Dashboard</Link>
                </li>
                <li>
                  <Link to="/pm/reports/sales">Sales Report</Link>
                </li>
                <li>
                  <Link to="/pm/reports/orders">Order Report</Link>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {can("users") && (
          <Accordion.Item eventKey="09">
            <Accordion.Header className="sidebar-menu">
              <i className="fa fa-users" style={iconStyle} aria-hidden="true"></i>
              {"   "} Users
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <Link to="/admin/users">Manage Users</Link>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {can("withdraw") && (
          <Accordion.Item eventKey="05">
            <Accordion.Header className="sidebar-menu">
              <i className="fa fa-dollar" style={iconStyle} aria-hidden="true"></i>
              {"   "} Withdraw
            </Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>
                  <Link to="/agent/withdraw">Manage Withdraw</Link>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
      <div style={{ width: "90%", margin: "15px auto 0" }}>
        <button
          type="button"
          onClick={signoutHandler}
          className="btn btn-light w-100 d-flex align-items-center justify-content-center"
          style={{ borderRadius: 10, fontWeight: 600 }}
        >
          <i className="fa fa-sign-out" style={{ paddingRight: 8 }} aria-hidden="true"></i>
          Logout
        </button>
      </div>
    </div>
  );
}
